import {Component, Input, OnDestroy, OnInit} from '@angular/core';
import {Router} from '@angular/router';
import {Subscription} from 'rxjs';
import {IdexService} from '../../idex.service';

@Component({
   selector: 'app-company-menu',
   templateUrl: './admin-menu.component.html',
   styleUrls: ['./admin-menu.component.css']
})
export class AdminMenuComponent implements OnInit, OnDestroy {
   @Input() companyPath;

   user: any;
   user_role: any;
   hideMenu:boolean = false;
   allowListEnabled = false;
   private siteSub?: Subscription;

   constructor(private router: Router, public service: IdexService) {
      this.user = this.service.user;
   }

   ngOnInit() {
      this.user_role = this.user.role;
      this.service.role = this.user_role;
      const isAdminTool = localStorage.getItem('admin-tool');
      if (isAdminTool && isAdminTool === 'true') {
         this.hideMenu = true;
      } else {
         localStorage.removeItem('admin-tool');
      }
      // Check once for the site already in context, then re-check whenever the site changes
      // (company-profile sets the tin asynchronously after loading the company).
      this.checkAllowList();
      this.siteSub = this.service.siteChange.subscribe(() => this.checkAllowList());
   }

   ngOnDestroy(): void {
      this.siteSub?.unsubscribe();
   }

   // Show the IP / Client-ID allow-list menus only when the current site is mapped to a customer
   // (ext_customer_site). Without a mapping the page has nothing to manage.
   private checkAllowList(): void {
      const siteCode = localStorage.getItem('tin');
      if (!siteCode) { this.allowListEnabled = false; return; }
      this.service.isAllowListEnabled(siteCode)
         .subscribe((enabled: boolean) => this.allowListEnabled = !!enabled, () => this.allowListEnabled = false);
   }

   getPath() {
      return window.localStorage.getItem('path_company');
   }

}
